import Service from "./Service";
const baseurl = '/api/procedimientos-resultados';
export default {
    index(params = {}) {
        return Service.get(`${baseurl}`, {
            params :  params
        });
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByIdEmbarazo(id) {
        return Service.get(`${baseurl}/show-by-idEmbarazo/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
}